/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_6_ClientInputs */

const et_portfolio_project_6_client = /** @type {(inputs: Portfolio_Project_6_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EFFIDIGITAL (AI turundusagentuur)`)
};

const en_portfolio_project_6_client = /** @type {(inputs: Portfolio_Project_6_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EFFIDIGITAL (AI marketing agency)`)
};

/**
* | output |
* | --- |
* | "EFFIDIGITAL (AI marketing agency)" |
*
* @param {Portfolio_Project_6_ClientInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_6_client = /** @type {((inputs?: Portfolio_Project_6_ClientInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_6_ClientInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_6_client(inputs)
	return en_portfolio_project_6_client(inputs)
});